import { render, staticRenderFns } from "./SearchResult2.vue?vue&type=template&id=48a27801&scoped=true&"
import script from "./SearchResult2.vue?vue&type=script&lang=js&"
export * from "./SearchResult2.vue?vue&type=script&lang=js&"
import style0 from "./SearchResult2.vue?vue&type=style&index=0&id=48a27801&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a27801",
  null
  
)

export default component.exports